module.exports = __webpack_public_path__ + "img/Settings.8ecce1f6.svg";